// @flow

import {pollinate} from './pollination/';
import type {TypePollen} from './pollination/pollen';

const pollinateSproutLink = (spec: TypePollen, extraProperties: Object = {}) => {
	pollinate(spec, extraProperties);
};

export {pollinateSproutLink};
